import { useQuery, skipToken } from '@tanstack/react-query'
import * as Sentry from '@sentry/react'
import useSession from './useSession'
import {
  fetchClassroomsByEventId,
  fetchContributionsByParticipationId,
  getSchoolDetails,
} from '@/services/contribution/api'
import usePhoto from './usePhoto'
import { APIQueryError, retryOnNetworkError } from '@/util/errors'
export { usePhoto }

export function useClassrooms() {
  const { session } = useSession()

  return useQuery({
    queryKey: ['classrooms'],
    queryFn: session ? () => fetchClassroomsByEventId(session.eventId) : skipToken,
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    enabled: !!session,
  })
}

export function useContributions() {
  const { session } = useSession()

  return useQuery({
    queryKey: ['contributions'],
    queryFn: session ? () => fetchContributionsByParticipationId(session.participationId) : skipToken,
    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    enabled: !!session,
  })
}

export function useSchool(schoolSlug: string | undefined) {
  if (schoolSlug === 'undefined') {
    // TODO: this is used to search for a bug.
    Sentry.logger.error('School slug is string "undefined" in useSchool')
    throw new APIQueryError('school slug is the string "undefined"')
  }

  return useQuery({
    queryKey: ['school', schoolSlug],
    queryFn: schoolSlug ? () => getSchoolDetails(schoolSlug) : skipToken,
    staleTime: 300000, //5 minutes
    gcTime: 300000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    enabled: !!schoolSlug,
    retry: retryOnNetworkError,
  })
}
